
export class UserModel {
  

    public UserID : number;
    public  UserName: string;
    public  PasswordHash:string  ;
    public  FirstName:string  ;
    public  LastName: string ;
    public  SecurityStamp: string  ;
    public  Discriminator: string  ;
    public  i_Customer: string  ;  
    public  i_Account:  string ;
    public  AccountID: string  ;
    public DefaultPassword: string;
    public token: string;
    public OperatorID: number;
    public EntryDate : string ;
    public UserType:number;
    public Balance: number;
    public MobilePhone :string ;
    public KycStatus :string ;
    public NIN:string;
    public NINStatus:string|null;


    constructor(UserID?: number, UserName?: string, PasswordHash?: string, FirstName?: string, LastName?:string,SecurityStamp? :string,
        discriminator?: string,i_Customer? :string,AccountID?: string, i_Account?:string ,defaultPassword?:string , OperatorID?:number ,EntryDate? :string ,
        UserType? :number,Balance? :number, MobilePhone?:string , KycStatus?:string,NINStatus?:string|null,NIN?:string  ) {

        this.UserID = UserID;
        this.UserName = UserName;
        this.PasswordHash = PasswordHash;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.SecurityStamp=SecurityStamp ;
        this.Discriminator = discriminator;
        this.i_Customer  =i_Customer ;
        this.i_Account= i_Account;
        this.AccountID = AccountID;
        this.DefaultPassword  =defaultPassword ;
        this.OperatorID = OperatorID;
        this.EntryDate=EntryDate;
        this.UserType=UserType;
        this.Balance=Balance;
        this.MobilePhone =MobilePhone;
        this.KycStatus = KycStatus;
        this.NIN=NIN;
        this.NINStatus=NINStatus;


     

    }


 
}
